import { render, staticRenderFns } from "./IceCream.vue?vue&type=template&id=5c87f84f"
import script from "./IceCream.vue?vue&type=script&lang=js"
export * from "./IceCream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports